/**
 * The MSAL configuration every Higgins SPA uses, so it isn't copied per app
 * (jscpd caught the eighth copy, PR #288). Two deliberate choices, both for
 * phones and iPads (site-file-sharing docs/MOBILE-SSO.md):
 *  - localStorage cache, so a sign-in survives a browser restart;
 *  - redirects back to the app's own origin (apps use redirect flows only,
 *    because silent iframe renewal is blocked by WebKit cookie rules).
 * Only errors are logged, and never a message MSAL flags as containing PII.
 *
 * Structural like startMsalApp, so this package doesn't depend on
 * @azure/msal-browser: pass the result to `new PublicClientApplication(...)`.
 */

/** MSAL's LogLevel.Error (msal-common: Error = 0). */
const MSAL_LOG_LEVEL_ERROR = 0;

export function createMsalConfig(options: { clientId: string; tenantId: string; origin?: string }) {
  const origin = options.origin ?? window.location.origin;
  return {
    auth: {
      clientId: options.clientId,
      authority: `https://login.microsoftonline.com/${options.tenantId}`,
      redirectUri: origin,
      postLogoutRedirectUri: origin,
    },
    cache: { cacheLocation: 'localStorage' as const },
    system: {
      loggerOptions: {
        logLevel: MSAL_LOG_LEVEL_ERROR,
        loggerCallback: (_level: unknown, message: string, containsPii: boolean) => {
          if (!containsPii) console.error('[MSAL]', message);
        },
      },
    },
  };
}
